import { SvgIcon, SvgIconProps } from "@mui/material";

const EraserIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<path
				d="M15.8334 16.667H7.08342L3.57509 13.0837C3.41988 12.9275 3.33276 12.7163 3.33276 12.4962C3.33276 12.276 3.41988 12.0648 3.57509 11.9087L11.9084 3.57534C12.0646 3.42013 12.2758 3.33301 12.4959 3.33301C12.7161 3.33301 12.9273 3.42013 13.0834 3.57534L17.2501 7.742C17.4053 7.89814 17.4924 8.10935 17.4924 8.3295C17.4924 8.54966 17.4053 8.76087 17.2501 8.917L9.58342 16.667M15.0001 11.0836L9.7501 5.83362"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};

export default EraserIcon;
